var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNearMe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 36 36"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#404347",
  d: "m20.35 36-5.7-14.65L0 15.65V13.5L36 0 22.5 36zm.9-5.7 9.6-25.15-25.1 9.6 11.2 4.3z"
})));
export default SvgNearMe;